require('./angular');
module.exports = angular;


/*** EXPORTS FROM exports-loader ***/
module.exports = window.angular;


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular/index.js
 ** module id = 13
 ** module chunks = 0
 **/